import React, {Component} from 'react';
import GoBackButton from './GoBackButton'
import {getText} from "./util/localization";
import {setProperties} from "./util/DefaultProperties";

const localization = require('../localization/localization-verified.json');
const queryString = require('query-string');

class Verified extends Component {

    constructor(props){
        super(props);

        let queryStringParams = queryString.parse(props.location.search);
        setProperties(queryStringParams);
    }

    render() {
        return (
            <div className="container">
                <h1>{getText(localization.title)}</h1>
                <p className="alert alert-success">{getText(localization.verificationSuccess)}</p>
                <GoBackButton {...this.props}/>
            </div>
        );
    }
}

export default Verified;



// WEBPACK FOOTER //
// ./src/js/Verified.js